import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogIn } from "lucide-react";

export default function LoginPage() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("admin@soestgp.de");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) nav("/admin");
    else setError(res.error || "Login fehlgeschlagen");
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6" data-testid="login-page">
      <form onSubmit={submit} className="card-surface w-full max-w-md p-8 chamfer-sm" data-testid="login-form">
        <div className="h-1 w-10 bg-[#00E5FF] mb-3" />
        <div className="eyebrow text-[#00E5FF]">Admin Zugang</div>
        <h1 className="font-display font-black italic uppercase text-4xl mt-2 leading-none">Login</h1>
        <p className="text-neutral-400 text-sm mt-2">Nur Redakteure & Liga-Admins.</p>

        <label className="block mt-6 text-xs uppercase tracking-widest text-neutral-400">E-Mail</label>
        <input type="email" value={email} onChange={e => setEmail(e.target.value)}
          required data-testid="login-email"
          className="w-full mt-2 bg-[#0B0F19] border border-white/10 px-4 py-3 focus:border-[#00E5FF] outline-none" />

        <label className="block mt-4 text-xs uppercase tracking-widest text-neutral-400">Passwort</label>
        <input type="password" value={password} onChange={e => setPassword(e.target.value)}
          required data-testid="login-password"
          className="w-full mt-2 bg-[#0B0F19] border border-white/10 px-4 py-3 focus:border-[#00E5FF] outline-none" />

        {error && <div className="mt-4 text-sm text-red-400" data-testid="login-error">{error}</div>}

        <button type="submit" disabled={loading} data-testid="login-submit"
          className="btn-primary chamfer-sm mt-6 w-full justify-center">
          <LogIn className="w-4 h-4" /> {loading ? "Anmelden..." : "Einloggen"}
        </button>
      </form>
    </div>
  );
}
